import { useEffect, useState } from 'react';

/**
 * Render a timezone as UTC and then swap it for the user's time on the client only after initial render.
 * This is to prevent React errors where the Client and Server HTML do not match.
 */
export const useClientTimeZone = () => {
    const [timezone, setTimezone] = useState('UTC');
    useEffect(() => {
        setTimezone(undefined);
    });
    return timezone;
};
